import isEmail from './isEmail';

export default function validateEmail(email: string) {
  try {
    return isEmail(email);
  } catch (error) {
    return false;
  }
}
